const ManifestoSection = () =>
{
    return <section class="manifesto" aria-label="Playa Pictures introduction">
      <div class="section-number">00 / 04</div>
      <p class="manifesto-lead">
        We blend <strong>25+ years of production craft</strong> with a new generation of creative tools.
      </p>
      <p class="manifesto-side">
        From first spark to final frame, Playa Pictures builds visual worlds with story at the center and technology in service of the idea.
      </p>
    </section>
}

export default ManifestoSection